export default "__VITE_ASSET__DAJmk8Vf__"